import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useFeedItems, useHeroItems, useUserStatusRefresh } from '../modules';
import { CardLoader, Cell, LoaderAnimated, Row } from '../components';
import { useAppDispatch, useAppSelector } from '../store';
import { selectUserStatus } from '../store/slices/userStatus.slice';
import { apiService, configService } from '../services';
import i18n from "../i18n";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { InteractionEventType } from 'outbound-api-client/lib/models';

export const Home: React.FC = () => {

  // Log "Page View" Interaction
  useEffect(() => {
    try {
      let path = window.location.pathname;
      apiService.postInteraction(InteractionEventType.WebPageView, 'PageView', path);
    } catch (err) {
      console.log(err);
    }
  }, []);


  const t = i18n.t;

  const [isPageLoading, setPageLoading] = useState(true);

  const dispatch = useAppDispatch();
  const userStatus = useAppSelector(selectUserStatus);
  const {
    FeedContent,
    hasContent,
    isLoading
  } = useFeedItems();

  const {
    HeroFeed
  } = useHeroItems();

  useUserStatusRefresh(dispatch);

  useEffect(() => {
    if (!isLoading && hasContent && isPageLoading && userStatus.isLoaded) {
      setPageLoading(false);
    }
  }, [isLoading, hasContent, isPageLoading, userStatus.isLoaded]);


  let appId = process.env.REACT_APP_CLIENTID;

  // Custom home page for Zebra Technologies
  if (appId === "zebratechnologies") {
    return (
      <>
        <Helmet>
          <title>{configService.current().applicationTitle} | {t("page_title_home")}</title>
        </Helmet>
        <div className='home-page'>
          <div className='featureed-container'>
            <div className='feature-campaign-container'>
              <div className='content'>
                <h1 dangerouslySetInnerHTML={{ __html: t("home_welcome") }}></h1>
                <hr />
                <Link className='btn btn-primary' to={t("button_discover_link")}>{t("button_discover_text")} <FontAwesomeIcon icon={faAngleRight} /></Link>
              </div>
            </div>
            <div className='carousel'>
              <HeroFeed />
            </div>
          </div>
          <main>
            <div className='container'>
              <h2>{t("heading_news")}</h2>


              {isLoading ? <LoaderAnimated /> : <FeedContent />}


            </div>
          </main>
        </div>
      </>
    )
  }





  // Default home page for other themes
  return (
    <div>
      <Helmet>
        <title>{configService.current().applicationTitle} - Home</title>
      </Helmet>
      <div className='hero-container'>
        <HeroFeed />
      </div>
      <h2 className="text-center font-title  m-bottom-0">Partner Feed</h2>
      <p className='text-center'>Find out what's going on in Canon.</p>
      <div className="w-100">
        {isPageLoading ? (
          <Row className='overflow-hidden'>
            <Cell $baseSize={6} $SMSize={4} $LGSize={3}>
              <CardLoader />
            </Cell>
            <Cell $baseSize={6} $SMSize={4} $LGSize={3}>
              <CardLoader />
            </Cell>
            <Cell $baseSize={6} $SMSize={4} $LGSize={3}>
              <CardLoader />
            </Cell>
            <Cell $baseSize={6} $SMSize={4} $LGSize={3}>
              <CardLoader />
            </Cell>
          </Row>
        ) : (
          <FeedContent />
        )}
      </div>
    </div>
  )
}